import Config from '../../config';

const initialState = {
    current: Config.language,
    items: [],
    select: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'GET_GLOBALS':
        case 'SET_LANGUAGES':
            const select = [];

            action.payload.languages.forEach((language) => {
                select.push({
                    id: language.id,
                    title: language.code
                });
            });

            return {
                ...state,
                items: action.payload.languages,
                select: select
            };
        case 'SET_LANGUAGE':
            return {
                ...state,
                current: action.payload.language
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/language.js